import { API } from '@config';
import { CorporateFinancialsTable } from '@src/types/CorporateFinancials';

export const getFinancialsBondStatements = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/financials-bond-statements?populate=File&sort=id%3Adesc`, options);
  const data: CorporateFinancialsTable = await response.json();

  return data;
};
